// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { OrgRef, OrgRefT, verifyOrgRef } from "./org-ref";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * GET /servers/light — minimal server info with nested org.
 * Matches Go: models.ServerLight { Name, Organization{ID,Name}, ID }
 */
export class ServerLight implements flatbuffers.IUnpackableObject<ServerLightT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ServerLight {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsServerLight(bb: flatbuffers.ByteBuffer, obj?: ServerLight): ServerLight {
    return (obj || new ServerLight()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsServerLight(
    bb: flatbuffers.ByteBuffer,
    obj?: ServerLight,
  ): ServerLight {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ServerLight()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  name(): string;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  name(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  organization(obj?: OrgRef): OrgRef | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new OrgRef()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  static startServerLight(builder: flatbuffers.Builder) {
    builder.startObject(3);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, nameOffset, 0);
  }

  static addOrganization(builder: flatbuffers.Builder, organizationOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, organizationOffset, 0);
  }

  static endServerLight(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    builder.requiredField(offset, 6); // name
    return offset;
  }

  unpack(): ServerLightT {
    return new ServerLightT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.name(),
      this.organization() !== null ? this.organization()!.unpack() : null,
    );
  }

  unpackTo(_o: ServerLightT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.name = this.name();
    _o.organization = this.organization() !== null ? this.organization()!.unpack() : null;
  }

  unpackFields(...fields: string[]): ServerLightT {
    const t = new ServerLightT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("organization")) {
      t.organization = this.organization() !== null ? this.organization()!.unpack() : null;
    }
    return t;
  }
}

export class ServerLightT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public name: string | Uint8Array | null = null,
    public organization: OrgRefT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    if (this.name === null || this.name === undefined) {
      throw new Error('Required field "name" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const organization = this.organization !== null ? this.organization!.pack(builder) : 0;

    ServerLight.startServerLight(builder);
    ServerLight.addId(builder, id);
    ServerLight.addName(builder, name);
    ServerLight.addOrganization(builder, organization);

    return ServerLight.endServerLight(builder);
  }

  clone(): ServerLightT {
    const obj = new ServerLightT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.name = this.name;
    obj.organization = this.organization !== null ? this.organization!.clone() : null;
    return obj;
  }

  equals(other: ServerLightT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.name !== other.name) return false;
    if (this.organization !== null && other.organization !== null) {
      if (!this.organization!.equals(other.organization!)) return false;
    } else if (this.organization !== other.organization) return false;
    return true;
  }
}

export function verifyServerLight(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "name");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyOrgRef(verifier, fieldPos + tableOffset);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
